import { useContext } from 'react';

import { ReviewResultContext } from './review-result-provider';

export function useReviewResult() {
  const context = useContext(ReviewResultContext);

  if (!context) {
    throw new Error('useReviewResult must be used within a ReviewResultProvider');
  }

  return context;
}
